module.exports = __webpack_public_path__ + "static/img/暂无订单.aec29e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无订单.jpg
// module id = lo56
// module chunks = 1